import { useEffect, useState, useContext } from 'react'
import { ConfirmModal } from 'mobily-ui-library/lib'
import { useTranslation } from 'react-i18next'

import TrackMyOrder from './components/TrackMyOrder/TrackMyOrder'
import OtpScreen from './components/OtpScreen/OtpScreen'
import ListOfOrders from './components/ListOfOrders/ListOfOrders'
import OrderDetails from './components/OrderDetails/OrderDetails'
import DeliveryDetails from './components/DeliveryDetails/DeliveryDetails'
import CancelTransferRequest from './components/CancelTransferRequest/CancelTransferRequest'

import { GlobalContext } from './context/GlobalContext'
import './TrackOrderManager.scss'
import SessionExpired from './components/SessionExpired/SessionExpired'

const TrackOrderManager = () => {
  const [state, dispatch]: any = useContext(GlobalContext)
  const { pageToDisplay } = state
  const { t } = useTranslation()
  const [browserBackClick, setBrowserBackClick] = useState(false)
  const win: any = window
  const serverURL = win['base_portal_url']
  const homePageURL = win['home_page_url']

  const handleStopTracking = () => {
    setBrowserBackClick(false)
    win.onpopstate = undefined
    if (win.location.href.includes('localhost')) {
      // dispatch({ type: 'GO_TO_HOME_SCREEN', payload: { page: 'TrackMyOrder' } })
      window.location.href = serverURL + homePageURL
    } else {
      window.location.href = serverURL + homePageURL
    }
  }

  const stopBrowserBack = () => {
    win.history.pushState(null, '', win.location.href)
    win.onpopstate = () => {
      win.history.pushState(null, '', win.location.href)
      setBrowserBackClick(true)
    }
  }

  useEffect(() => {
    stopBrowserBack()
  }, [])

  return (
    <>
      <>
        {pageToDisplay === 'TrackMyOrder' && <TrackMyOrder />}
        {pageToDisplay === 'OtpScreen' && <OtpScreen />}
        {pageToDisplay === 'ListOfOrders' && <ListOfOrders />}
        {pageToDisplay === 'OrderDetails' && <OrderDetails />}
        {pageToDisplay === 'DeliveryDetails' && <DeliveryDetails />}
        {pageToDisplay === 'CancelTransferRequest' && <CancelTransferRequest />}
        {pageToDisplay === 'SessionExpired' && <SessionExpired/>}
      </>
      <div className="browserBackClickModal">
        <ConfirmModal
          title={t('browser_back_click_popup_title')}
          subText={t('browser_back_click_popup_subTitle')}
          buttonName={t('continue_tracking')}
          outlineButtonName={t('stop_tracking')}
          showModal={browserBackClick}
          onClickClose={() => setBrowserBackClick(false)}
          onclickButton={() => setBrowserBackClick(false)}
          onclickOutLineButton={handleStopTracking}
        />
      </div>
    </>
  )
}

export default TrackOrderManager
